import { Lock, Shield, BadgeCheck, Eye } from "lucide-react";
import { PageHero, Section } from "@/components/SharedUI";
import Term, { TERMS } from "@/components/Term";

const items = [
  [Lock, "Not a database of culture", "BIGIBILA SYSTEMS™ is not designed to extract, own or centralise Aboriginal cultural knowledge. It supports authority, permission, protection, accountability and evidence."],
  [Shield, "Cultural authority remains central", "The platform supports governance controls. It does not replace Aboriginal authority, cultural decision-making, community consent or legal advice."],
  [BadgeCheck, "Background IP notice", <>Bigibila Advisory Method™, <Term def={TERMS.LoreLed}>Lore-Led Architecture™</Term>, Aboriginal Governance Architecture Model™, <Term def={TERMS.LoreGate}>Lore-Gate™</Term> and related toolkit materials are asserted as Bigibila-owned background intellectual property unless otherwise agreed in writing.</>],
  [Eye, "Demo data only", "All demo records are fictional sample data. No real community, cultural, client, family or sensitive information is stored in the demo environment."],
];

export default function Assurance() {
  return (
    <>
      <PageHero
        eyebrow="Governance, safety and assurance"
        title="Protect first. Package clearly. Pilot safely. Scale with authority."
        desc="This page sets the safety boundary for the product, demo and public website. It protects Bigibila, clients, communities and cultural material."
      />

      <section className="border-b border-stone-200">
        <Section>
          <div className="grid gap-px bg-stone-200 border border-stone-200 md:grid-cols-2">
            {items.map(([Icon, title, desc]) => (
              <div key={title} className="bg-[#FAFAF9] p-8 hover-rise" data-testid={`assurance-${title.toLowerCase().replace(/\s+/g, '-')}`}>
                <Icon className="h-6 w-6 text-[#9C4221] mb-5" strokeWidth={1.5} />
                <h3 className="font-display text-xl tracking-tight font-bold text-stone-900">{title}</h3>
                <p className="mt-3 text-sm text-stone-700 leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
        </Section>
      </section>

      <section className="border-b border-stone-200">
        <Section>
          <div className="border border-[#9C4221]/30 bg-[#9C4221]/[0.06] p-8 max-w-4xl">
            <h3 className="font-display text-xl tracking-tight font-bold text-stone-900">Public launch control</h3>
            <p className="mt-3 text-stone-800 leading-relaxed">
              Build privately first. Test the demo. Review cultural handling. Confirm legal/IP wording. Then publish only the public-facing version.
            </p>
          </div>
        </Section>
      </section>
    </>
  );
}
